import type { Place } from "./schema";
import { capitalPlaces } from "./capitalPlaces";

const checkedAt = "2026-08-10";

const southeastPlaces: Place[] = [
  {
    id: "national-busan-science-museum",
    name: "국립부산과학관",
    category: "science-creative",
    region: "busan",
    district: "기장군",
    neighborhood: "오시리아",
    address: "부산광역시 기장군 기장읍 동부산관광6로 59",
    coordinates: { lat: 35.2057, lng: 129.2159 },
    summary: "상설전시, 새싹누리관, 야외 전시를 갖춘 과학 체험 공간.",
    dadTip: "기차·우주·자동차 등 관심 있는 주제를 골라 관람하세요.",
    ageFit: 5,
    rainFriendly: true,
    indoorOutdoor: "mixed",
    priceType: "mixed",
    stayTime: "2-4h",
    openDays: ["tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
    closedNote: "월요일 휴관 가능성이 높아 방문 전 확인 권장",
    website: "https://www.sciport.or.kr/",
    reservationRequired: false,
    tags: ["과학", "오시리아", "실내", "기차", "체험"],
    source: [
      {
        label: "국립부산과학관 공식 홈페이지",
        url: "https://www.sciport.or.kr/",
        checkedAt,
        status: "official",
      },
    ],
  },
  {
    id: "lotte-world-adventure-busan",
    name: "롯데월드 어드벤처 부산",
    category: "theme-park",
    region: "busan",
    district: "기장군",
    neighborhood: "오시리아",
    address: "부산광역시 기장군 기장읍 동부산관광로 42",
    coordinates: { lat: 35.1925, lng: 129.2127 },
    summary: "놀이기구, 퍼레이드, 캐릭터 경험을 한 번에 묶을 수 있는 부산권 대표 테마파크.",
    dadTip: "놀이기구별 키 제한을 확인하고 탑승 가능한 기구를 먼저 골라두세요.",
    ageFit: 4,
    rainFriendly: false,
    indoorOutdoor: "outdoor",
    priceType: "paid",
    stayTime: "half-day",
    openDays: ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
    website: "https://adventurebusan.lotteworld.com/",
    reservationRequired: false,
    tags: ["놀이공원", "오시리아", "퍼레이드", "유료"],
    source: [
      {
        label: "롯데월드 어드벤처 부산 공식 홈페이지",
        url: "https://adventurebusan.lotteworld.com/",
        checkedAt,
        status: "official",
      },
    ],
  },
  {
    id: "busan-aquarium",
    name: "SEA LIFE 부산아쿠아리움",
    category: "animal-eco",
    region: "busan",
    district: "해운대구",
    neighborhood: "해운대",
    address: "부산광역시 해운대구 해운대해변로 266",
    coordinates: { lat: 35.1598, lng: 129.1611 },
    summary: "해운대 해변 바로 앞에서 수중 터널과 해양 생물을 볼 수 있는 실내형 수족관.",
    dadTip: "비 오는 날 대체 코스로 강하고, 관람 뒤 해운대 산책이나 모래놀이를 붙이기 좋습니다.",
    ageFit: 5,
    rainFriendly: true,
    indoorOutdoor: "indoor",
    priceType: "paid",
    stayTime: "1-2h",
    openDays: ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
    website: "https://www.visitsealife.com/busan/",
    tags: ["수족관", "해운대", "실내", "비오는날"],
    source: [
      {
        label: "SEA LIFE 부산아쿠아리움 공식 홈페이지",
        url: "https://www.visitsealife.com/busan/",
        checkedAt,
        status: "official",
      },
    ],
  },
  {
    id: "busan-citizen-park",
    name: "부산시민공원",
    category: "park",
    region: "busan",
    district: "부산진구",
    neighborhood: "연지동",
    address: "부산광역시 부산진구 시민공원로 73",
    coordinates: { lat: 35.1684, lng: 129.0575 },
    summary: "도심 한가운데 넓은 잔디, 산책로, 놀이터를 갖춘 반나절 야외 코스.",
    dadTip: "킥보드나 공놀이처럼 아이 에너지를 빼는 목적이면 만족도가 높고, 더운 날은 그늘 동선을 먼저 확인하세요.",
    ageFit: 4,
    rainFriendly: false,
    indoorOutdoor: "outdoor",
    priceType: "free",
    stayTime: "2-4h",
    openDays: ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
    tags: ["공원", "무료", "놀이터", "피크닉"],
    source: [
      {
        label: "부산시민공원 안내",
        checkedAt,
        status: "needs-check",
        note: "운영시간 및 시설별 이용 가능 여부 추가 검증 필요",
      },
    ],
  },
  {
    id: "busan-childrens-grand-park",
    name: "부산어린이대공원",
    category: "park",
    region: "busan",
    district: "부산진구",
    neighborhood: "초읍",
    address: "부산광역시 부산진구 새싹로 295",
    coordinates: { lat: 35.1821, lng: 129.0467 },
    summary: "숲, 산책, 놀이터, 체험시설을 함께 엮기 좋은 전통적인 가족 나들이 장소.",
    dadTip: "걷는 양이 꽤 생길 수 있어서 간식과 물을 챙기고, 아이 컨디션에 맞춰 짧은 루프로 잡는 게 좋습니다.",
    ageFit: 4,
    rainFriendly: false,
    indoorOutdoor: "outdoor",
    priceType: "free",
    stayTime: "2-4h",
    openDays: ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
    tags: ["숲", "놀이터", "무료", "산책"],
    source: [
      {
        label: "부산어린이대공원 안내",
        checkedAt,
        status: "needs-check",
      },
    ],
  },
  {
    id: "busan-childrens-complex-library",
    name: "부산 어린이복합문화공간 들락날락",
    category: "deullak-nallak",
    region: "busan",
    district: "연제구",
    neighborhood: "시청",
    address: "부산광역시 연제구 중앙대로 1001",
    coordinates: { lat: 35.1798, lng: 129.075 },
    summary: "부산시청권에서 접근성이 좋고, 책·놀이·디지털 체험을 한 번에 묶는 들락날락 대표 거점.",
    dadTip: "시청 방문 일정이나 근처 식사와 붙이기 좋고, 프로그램 예약 여부를 먼저 보면 헛걸음을 줄일 수 있습니다.",
    ageFit: 5,
    rainFriendly: true,
    indoorOutdoor: "indoor",
    priceType: "free",
    stayTime: "1-2h",
    openDays: ["tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
    closedNote: "시설별 휴관일 확인 필요",
    tags: ["들락날락", "무료", "실내", "책", "디지털"],
    source: [
      {
        label: "부산광역시 들락날락 공식 안내",
        checkedAt,
        status: "official",
      },
    ],
  },
  {
    id: "busan-library-dream-deullak",
    name: "부산도서관 꿈뜨락 들락날락",
    category: "deullak-nallak",
    region: "busan",
    district: "사상구",
    neighborhood: "덕포동",
    address: "부산광역시 사상구 사상로310번길 33",
    coordinates: { lat: 35.1721, lng: 128.9837 },
    summary: "부산도서관 안에서 어린이 독서와 복합문화 체험을 연결할 수 있는 서부산권 거점.",
    dadTip: "책 읽기만 기대하기보다 전시·체험·어린이자료실을 같이 묶으면 아이 몰입도가 올라갑니다.",
    ageFit: 5,
    rainFriendly: true,
    indoorOutdoor: "indoor",
    priceType: "free",
    stayTime: "1-2h",
    openDays: ["tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
    closedNote: "월요일 및 공휴일 운영 여부 확인 권장",
    website: "https://library.busan.go.kr/",
    tags: ["들락날락", "도서관", "무료", "실내", "서부산"],
    source: [
      {
        label: "부산도서관 공식 홈페이지",
        url: "https://library.busan.go.kr/",
        checkedAt,
        status: "official",
      },
    ],
  },
  {
    id: "busan-museum",
    name: "부산박물관",
    category: "museum",
    region: "busan",
    district: "남구",
    neighborhood: "대연동",
    address: "부산광역시 남구 유엔평화로 63",
    coordinates: { lat: 35.1293, lng: 129.0932 },
    summary: "부산의 역사와 문화를 가볍게 접할 수 있는 실내 박물관.",
    dadTip: "유물이나 전시 주제 한두 가지를 골라 짧게 관람하세요.",
    ageFit: 3,
    rainFriendly: true,
    indoorOutdoor: "indoor",
    priceType: "free",
    stayTime: "1-2h",
    openDays: ["tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
    closedNote: "월요일 휴관 가능성이 높아 확인 권장",
    website: "https://museum.busan.go.kr/",
    tags: ["박물관", "무료", "실내", "역사"],
    source: [
      {
        label: "부산박물관 공식 홈페이지",
        url: "https://museum.busan.go.kr/",
        checkedAt,
        status: "official",
      },
    ],
  },
  {
    id: "busan-marine-natural-history-museum",
    name: "부산해양자연사박물관",
    category: "animal-eco",
    region: "busan",
    district: "동래구",
    neighborhood: "온천동",
    address: "부산광역시 동래구 우장춘로 175",
    coordinates: { lat: 35.219, lng: 129.0771 },
    summary: "해양 생물, 자연사 표본, 어린이 눈높이 전시를 볼 수 있는 실내형 박물관.",
    dadTip: "금강공원이나 온천장 주변 일정과 이어 붙이면 이동 피로가 적습니다.",
    ageFit: 4,
    rainFriendly: true,
    indoorOutdoor: "indoor",
    priceType: "free",
    stayTime: "1-2h",
    openDays: ["tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
    closedNote: "월요일 휴관 가능성이 높아 확인 권장",
    website: "https://www.busan.go.kr/sea/",
    tags: ["해양", "자연사", "동물", "무료", "실내"],
    source: [
      {
        label: "부산해양자연사박물관 공식 안내",
        url: "https://www.busan.go.kr/sea/",
        checkedAt,
        status: "official",
      },
    ],
  },
  {
    id: "busan-119-safety-experience-center",
    name: "부산119안전체험관",
    category: "science-creative",
    region: "busan",
    district: "동래구",
    neighborhood: "온천동",
    address: "부산광역시 동래구 우장춘로 117",
    coordinates: { lat: 35.2217, lng: 129.0792 },
    summary: "화재, 지진, 생활안전 등을 아이 눈높이에서 체험할 수 있는 예약형 안전 교육 공간.",
    dadTip: "예약형 프로그램이 핵심이라 날짜를 먼저 맞추고, 체험 뒤 아이와 안전 약속을 하나 정하면 기억에 남습니다.",
    ageFit: 5,
    rainFriendly: true,
    indoorOutdoor: "indoor",
    priceType: "free",
    stayTime: "1-2h",
    openDays: ["tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
    closedNote: "예약 및 휴관일 확인 필수",
    website: "https://119.busan.go.kr/",
    reservationRequired: true,
    tags: ["안전", "체험", "예약", "무료", "실내"],
    source: [
      {
        label: "부산119안전체험관 공식 홈페이지",
        url: "https://119.busan.go.kr/",
        checkedAt,
        status: "official",
      },
    ],
  },
  {
    id: "busan-cinema-center-deullak",
    name: "영화의전당 들락날락",
    category: "deullak-nallak",
    region: "busan",
    district: "해운대구",
    neighborhood: "센텀시티",
    address: "부산광역시 해운대구 수영강변대로 120",
    coordinates: { lat: 35.1712, lng: 129.1276 },
    summary: "센텀권에서 영화·문화 공간과 어린이복합문화공간을 함께 엮을 수 있는 지점.",
    dadTip: "센텀시티 실내 일정과 결합하기 좋아서 날씨가 애매한 날 후보로 넣어두면 좋습니다.",
    ageFit: 4,
    rainFriendly: true,
    indoorOutdoor: "indoor",
    priceType: "free",
    stayTime: "1-2h",
    openDays: ["tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
    closedNote: "프로그램 및 운영일 확인 권장",
    website: "https://www.dureraum.org/",
    tags: ["들락날락", "센텀", "영화", "무료", "실내"],
    source: [
      {
        label: "영화의전당 공식 홈페이지",
        url: "https://www.dureraum.org/",
        checkedAt,
        status: "official",
      },
    ],
  },
  {
    id: "busan-museum-of-art",
    name: "부산시립미술관",
    category: "art-exhibit",
    region: "busan",
    district: "해운대구",
    neighborhood: "센텀시티",
    address: "부산광역시 해운대구 APEC로 58",
    coordinates: { lat: 35.1669, lng: 129.1371 },
    summary: "전시 주제에 따라 아이와 짧게 관람하기 좋은 센텀권 미술관.",
    dadTip: "어린이 친화 전시인지 먼저 확인하고, 관람 시간을 60분 안팎으로 잡으면 부담이 적습니다.",
    ageFit: 3,
    rainFriendly: true,
    indoorOutdoor: "indoor",
    priceType: "mixed",
    stayTime: "1-2h",
    openDays: ["tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
    closedNote: "월요일 휴관 및 전시 교체 기간 확인 권장",
    website: "https://art.busan.go.kr/",
    tags: ["미술관", "전시", "센텀", "실내"],
    source: [
      {
        label: "부산시립미술관 공식 홈페이지",
        url: "https://art.busan.go.kr/",
        checkedAt,
        status: "official",
      },
    ],
  },
  {
    id: "songdo-marine-cable-car",
    name: "송도해상케이블카",
    category: "transport",
    region: "busan",
    district: "서구",
    neighborhood: "송도",
    address: "부산광역시 서구 송도해변로 171",
    coordinates: { lat: 35.0766, lng: 129.0189 },
    summary: "바다 위를 지나는 케이블카 경험과 송도 해변 산책을 함께 즐길 수 있는 코스.",
    dadTip: "고소공포가 있으면 일반 캐빈을 고르고, 바람 강한 날은 운영 여부를 확인하세요.",
    ageFit: 4,
    rainFriendly: false,
    indoorOutdoor: "mixed",
    priceType: "paid",
    stayTime: "1-2h",
    openDays: ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
    website: "https://busanaircruise.co.kr/",
    tags: ["케이블카", "송도", "바다", "유료", "전망"],
    source: [
      {
        label: "송도해상케이블카 공식 홈페이지",
        url: "https://busanaircruise.co.kr/",
        checkedAt,
        status: "official",
      },
    ],
  },
  {
    id: "dadaepo-beach",
    name: "다대포해수욕장",
    category: "sea-water",
    region: "busan",
    district: "사하구",
    neighborhood: "다대동",
    address: "부산광역시 사하구 다대동",
    coordinates: { lat: 35.0472, lng: 128.9685 },
    summary: "넓은 모래사장, 낙조, 계절별 물놀이와 산책을 즐기기 좋은 서부산 바다 코스.",
    dadTip: "물놀이 시즌이 아니어도 모래놀이와 노을 산책 만족도가 높고, 바람막이를 챙기면 좋습니다.",
    ageFit: 4,
    rainFriendly: false,
    indoorOutdoor: "outdoor",
    priceType: "free",
    stayTime: "2-4h",
    openDays: ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
    tags: ["해변", "무료", "모래놀이", "노을"],
    source: [
      {
        label: "부산 관광 안내",
        checkedAt,
        status: "needs-check",
        note: "해수욕장 개장 기간과 편의시설 운영일 추가 검증 필요",
      },
    ],
  },
  {
    id: "samnak-eco-park",
    name: "삼락생태공원",
    category: "nature-forest",
    region: "busan",
    district: "사상구",
    neighborhood: "삼락동",
    address: "부산광역시 사상구 삼락동 29-46",
    coordinates: { lat: 35.1729, lng: 128.9769 },
    summary: "낙동강변 산책, 자전거, 넓은 잔디와 계절 꽃을 즐길 수 있는 서부산 자연 코스.",
    dadTip: "동선이 넓으니 목적지를 하나만 찍고 움직이는 게 좋고, 여름에는 그늘과 벌레 대비가 필요합니다.",
    ageFit: 4,
    rainFriendly: false,
    indoorOutdoor: "outdoor",
    priceType: "free",
    stayTime: "2-4h",
    openDays: ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
    tags: ["생태공원", "낙동강", "무료", "자전거", "산책"],
    source: [
      {
        label: "부산 낙동강관리본부 안내",
        checkedAt,
        status: "needs-check",
      },
    ],
  },
  {
    id: "busan-childrens-cultural-center",
    name: "부산글로벌빌리지 영어특화 들락날락",
    category: "deullak-nallak",
    region: "busan",
    district: "부산진구",
    neighborhood: "부전동",
    address: "부산광역시 부산진구 가야대로 734",
    coordinates: { lat: 35.1586, lng: 129.0536 },
    summary: "영어 놀이와 독서·체험을 함께하는 어린이복합문화공간.",
    dadTip: "프로그램별 대상 연령과 예약 여부를 확인하세요.",
    ageFit: 4,
    rainFriendly: true,
    indoorOutdoor: "indoor",
    priceType: "mixed",
    stayTime: "1-2h",
    openDays: ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday"],
    closedNote: "프로그램별 예약 및 운영일 확인 권장",
    tags: ["들락날락", "영어", "서면", "실내"],
    source: [
      {
        label: "부산글로벌빌리지 및 들락날락 안내",
        checkedAt,
        status: "needs-check",
      },
    ],
  },
  {
    id: "kidztopia-centum",
    name: "센텀 키즈카페 후보",
    category: "kids-cafe",
    region: "busan",
    district: "해운대구",
    neighborhood: "센텀시티",
    address: "부산광역시 해운대구 센텀 일대",
    coordinates: { lat: 35.1699, lng: 129.1305 },
    summary: "대형 쇼핑몰권 실내 놀이 후보군을 넣기 위한 키즈카페 샘플 레코드.",
    dadTip: "실제 업체명, 가격, 보호자 좌석, 주차 조건을 검증한 뒤 정식 레코드로 쪼개 넣으세요.",
    ageFit: 3,
    rainFriendly: true,
    indoorOutdoor: "indoor",
    priceType: "paid",
    stayTime: "1-2h",
    openDays: ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
    tags: ["키즈카페", "센텀", "실내", "검증필요"],
    source: [
      {
        label: "초기 구조 검증용 샘플 데이터",
        checkedAt,
        status: "needs-check",
        note: "정식 서비스 전 실제 사업장 정보로 교체 필요",
      },
    ],
  },
  {
    id: "maker-studio-sample",
    name: "도예·공방 체험 후보",
    category: "maker",
    region: "busan",
    district: "수영구",
    neighborhood: "광안리",
    address: "부산광역시 수영구 광안리 일대",
    coordinates: { lat: 35.1532, lng: 129.1187 },
    summary: "도예, 쿠킹, 만들기 체험을 담기 위한 공방형 샘플 레코드.",
    dadTip: "7살은 결과물이 바로 보이는 만들기 체험이 좋고, 예약·소요시간·보호자 동반 가능 여부가 중요합니다.",
    ageFit: 3,
    rainFriendly: true,
    indoorOutdoor: "indoor",
    priceType: "paid",
    stayTime: "1-2h",
    openDays: ["wednesday", "thursday", "friday", "saturday", "sunday"],
    tags: ["공방", "만들기", "광안리", "예약", "검증필요"],
    source: [
      {
        label: "초기 구조 검증용 샘플 데이터",
        checkedAt,
        status: "needs-check",
        note: "실제 업체 검증 후 정식 레코드로 교체 필요",
      },
    ],
  },
  {
    id: "gimhae-gaya-theme-park",
    name: "김해가야테마파크",
    category: "theme-park",
    region: "gyeongnam",
    district: "김해시",
    neighborhood: "어방동",
    address: "경상남도 김해시 가야테마길 161",
    coordinates: { lat: 35.2346, lng: 128.9058 },
    summary: "가야 역사 테마, 공연, 체험, 야외 놀이를 함께 엮을 수 있는 김해권 대표 테마형 코스.",
    dadTip: "부산 서부권에서 반나절 코스로 붙이기 좋고, 야외 이동이 많아 더운 날은 오전 방문이 편합니다.",
    ageFit: 4,
    rainFriendly: false,
    indoorOutdoor: "mixed",
    priceType: "paid",
    stayTime: "2-4h",
    openDays: ["tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
    closedNote: "운영일과 공연 일정 확인 권장",
    tags: ["김해", "가야", "테마", "역사", "야외"],
    source: [
      {
        label: "초기 경남 확장 샘플",
        checkedAt,
        status: "needs-check",
        note: "공식 운영시간, 요금, 좌표 추가 검증 필요",
      },
    ],
  },
  {
    id: "gimhae-lotte-water-park",
    name: "김해 롯데워터파크",
    category: "waterpark-pool",
    region: "gyeongnam",
    district: "김해시",
    neighborhood: "신문동",
    address: "경상남도 김해시 장유로 555",
    coordinates: { lat: 35.1853, lng: 128.8302 },
    summary: "실내외 물놀이 시설을 갖춘 김해의 워터파크.",
    dadTip: "아이 체력에 맞춰 이용 시간을 정하고 구명조끼와 휴식 공간을 확인하세요.",
    ageFit: 4,
    rainFriendly: false,
    indoorOutdoor: "mixed",
    priceType: "paid",
    stayTime: "half-day",
    openDays: ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
    tags: ["김해", "워터파크", "여름", "물놀이", "유료"],
    source: [
      {
        label: "초기 경남 확장 샘플",
        checkedAt,
        status: "needs-check",
        note: "시즌 운영일과 어린이 이용 조건 추가 검증 필요",
      },
    ],
  },
  {
    id: "clayarch-gimhae-museum",
    name: "클레이아크김해미술관",
    category: "art-exhibit",
    region: "gyeongnam",
    district: "김해시",
    neighborhood: "진례면",
    address: "경상남도 김해시 진례면 진례로 275-51",
    coordinates: { lat: 35.2469, lng: 128.7462 },
    summary: "도자와 건축, 미술 전시를 아이 눈높이의 만들기·관찰 경험으로 바꿀 수 있는 실내외 미술관.",
    dadTip: "전시와 체험 프로그램 일정, 대상 연령을 확인하세요.",
    ageFit: 3,
    rainFriendly: true,
    indoorOutdoor: "mixed",
    priceType: "mixed",
    stayTime: "1-2h",
    openDays: ["tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
    closedNote: "전시 교체와 휴관일 확인 권장",
    tags: ["김해", "미술관", "도자", "체험", "실내"],
    source: [
      {
        label: "초기 경남 확장 샘플",
        checkedAt,
        status: "needs-check",
        note: "공식 프로그램과 운영일 추가 검증 필요",
      },
    ],
  },
  {
    id: "yangsan-jangsan-forest-sample",
    name: "양산 숲·계곡 나들이 후보",
    category: "nature-forest",
    region: "gyeongnam",
    district: "양산시",
    neighborhood: "하북면·원동면 일대",
    address: "경상남도 양산시 자연휴양·계곡권",
    coordinates: { lat: 35.4018, lng: 129.0551 },
    summary: "부산 북부권에서 접근 가능한 숲, 계곡, 산책형 자연 코스를 담기 위한 양산권 샘플.",
    dadTip: "정식 장소 DB에는 주차장, 화장실, 유모차 가능 여부를 기준으로 세부 장소를 나눠 넣는 게 좋습니다.",
    ageFit: 3,
    rainFriendly: false,
    indoorOutdoor: "outdoor",
    priceType: "mixed",
    stayTime: "2-4h",
    openDays: ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
    tags: ["양산", "자연", "숲", "계곡", "검증필요"],
    source: [
      {
        label: "초기 경남 확장 샘플",
        checkedAt,
        status: "needs-check",
        note: "실제 후보지 단위로 쪼개고 편의시설 검증 필요",
      },
    ],
  },
  {
    id: "changwon-marine-park",
    name: "창원해양공원",
    category: "tourism-view",
    region: "gyeongnam",
    district: "창원시",
    neighborhood: "진해구",
    address: "경상남도 창원시 진해구 명동로 62",
    coordinates: { lat: 35.0789, lng: 128.7069 },
    summary: "바다 전망, 산책, 전시형 시설을 함께 묶을 수 있는 진해권 관광 코스.",
    dadTip: "부산에서 이동 시간이 있으니 근처 식사·카페·해안 산책까지 묶어 반나절 코스로 잡는 편이 좋습니다.",
    ageFit: 3,
    rainFriendly: false,
    indoorOutdoor: "mixed",
    priceType: "mixed",
    stayTime: "2-4h",
    openDays: ["tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
    tags: ["창원", "진해", "바다", "전망", "관광"],
    source: [
      {
        label: "초기 경남 확장 샘플",
        checkedAt,
        status: "needs-check",
        note: "운영 시설별 휴관일과 요금 추가 검증 필요",
      },
    ],
  },
  {
    id: "geoje-sea-world-sample",
    name: "거제 해양체험 후보",
    category: "animal-eco",
    region: "gyeongnam",
    district: "거제시",
    neighborhood: "일운면",
    address: "경상남도 거제시 일운면 일대",
    coordinates: { lat: 34.8215, lng: 128.6912 },
    summary: "거제권 해양 생태, 관광, 체험형 장소를 담기 위한 남해안 확장 샘플.",
    dadTip: "거제는 이동 부담이 커서 당일치기보다는 1박 여행 후보로 분리 태깅하는 게 좋습니다.",
    ageFit: 3,
    rainFriendly: false,
    indoorOutdoor: "mixed",
    priceType: "paid",
    stayTime: "half-day",
    openDays: ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
    tags: ["거제", "해양", "생태", "관광", "검증필요"],
    source: [
      {
        label: "초기 경남 확장 샘플",
        checkedAt,
        status: "needs-check",
        note: "정식 장소명, 운영 여부, 아이 체험 적합성 검증 필요",
      },
    ],
  },
  {
    id: "tongyeong-cable-car",
    name: "통영 케이블카·전망 코스",
    category: "transport",
    region: "gyeongnam",
    district: "통영시",
    neighborhood: "도남동",
    address: "경상남도 통영시 발개로 205",
    coordinates: { lat: 34.8274, lng: 128.4235 },
    summary: "케이블카와 한려수도 전망을 중심으로 통영 여행 동선을 만들 수 있는 관광형 후보.",
    dadTip: "부산 기준으로는 장거리라 숙박 여행 태그를 붙이고, 바람·대기 시간·아이 고소공포를 먼저 고려하세요.",
    ageFit: 3,
    rainFriendly: false,
    indoorOutdoor: "mixed",
    priceType: "paid",
    stayTime: "2-4h",
    openDays: ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
    tags: ["통영", "케이블카", "전망", "관광", "장거리"],
    source: [
      {
        label: "초기 경남 확장 샘플",
        checkedAt,
        status: "needs-check",
        note: "공식 운영시간, 휴장일, 좌표 추가 검증 필요",
      },
    ],
  },
];

export const places: Place[] = [...capitalPlaces, ...southeastPlaces];
